
























































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { CatalogListItem, CATALOG } from '@tt4b/ttam-enums';
import TargetingIcon from '@tt4b/ttam-assets/src/svgs/dpa-targeting-icon.svg';
import { i18n } from './../../../../i18n';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';

const name = 'ttam-product-source-catalog-item';
export default defineComponent({
  name,
  components: {
    TargetingIcon,
  },
  props: {
    source: {
      type: Object as PropType<CatalogListItem>,
      default: () => ({}),
    },
    onClick: {
      type: Function as PropType<(i: CatalogListItem) => void>,
      default: () => () => undefined,
    },
    currentItem: {
      type: Object as PropType<CatalogListItem>,
      default: () => ({}),
    },
    hideGotoCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { source, currentItem } = toRefs(props);
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);
    const isSelectedItem = computed(
      () => currentItem.value.platformId === source.value.platformId && currentItem.value.bc_id === source.value.bc_id,
    );
    // eslint-disable-next-line @tt4b/no-single-dependency-computed
    const prodSum = computed(() => source.value.prod_sum ?? 0);
    // eslint-disable-next-line @tt4b/no-single-dependency-computed
    const prodApprovedSum = computed(() => source.value.prod_approved_count ?? 0);

    return {
      CATALOG,
      aadvid,
      isSelectedItem,
      name,
      i18n,
      prodSum,
      prodApprovedSum,
    };
  },
});
